import useFetch from '@av-hooks/useFetch'
import {useAuth} from '@av-modules/auth'

const useFetchListCompany = () => {
  const {auth} = useAuth()
  const isAdmin = auth?.data?.user.role === 'SUPER_ADMIN'

  const {items, isLoading, refetch} = useFetch({
    path: 'company',
    invalidateKey: 'company',
    query: {
      page: 1,
      size: 1000,
    },
    enabled: isAdmin,
  })

  return {
    items,
    isLoading,
    isAdmin,
    auth,
    refetch,
  }
}

export default useFetchListCompany
